import { Navigate } from 'react-router-dom';

import { NBA_MARKET_COMMON_MARKET_ADD_CARD } from '@sorare/core/src/constants/__generated__/routes';

const AddCardPage = () => {
  return <Navigate to={NBA_MARKET_COMMON_MARKET_ADD_CARD} replace />;
};

export default AddCardPage;
